export default __webpack_public_path__ + "static/media/cover.37ae020e.svg";